import { useEffect } from 'react';
import { DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormGroup } from '@shared/ui/forms/display';
import { ListData } from '@shared/ui/parts';
import { formatBalanceUi } from '@utils/balance-helpers';
import { formatMonth } from '@utils/date-helpers';
import { EmailBtn, TelegramBtn } from '@widgets/buttons';
import ReferralDaysLeft from '@widgets/referrals/ReferralDaysLeft';

export default function ReferralInfoDialog({ data, setTitle, setSubtitle }) {
  const { t } = useTranslation();

  useEffect(() => {
    setTitle(data.name);
    setSubtitle(<ReferralDaysLeft days={data.expireDays} />);
  }, [data]);

  return (
    <DialogContent>
      <p className="body-18m">{t('Your income')}</p>
      <p
        className="title-h1r"
        dangerouslySetInnerHTML={{
          __html: formatBalanceUi(data.totalRevenue, 'USD', null, true),
        }}
      />
      <ListData
        listData={[
          { label: t('name'), value: data.name },
          { label: t('email'), value: data.email },
          { label: t('join_date'), value: formatMonth(data.created_at) },
        ]}
      />
      <br />
      <ListData
        listData={[{ label: t('Referral rate'), value: `${data.rate}%` }]}
      />
      <br />
      <FormGroup label={t('contacts')}>
        <div className="form">
          {data.email && <EmailBtn email={data.email} text={data.email} />}
          {data.telegram && (
            <TelegramBtn username={data.telegram} text={`@${data.telegram}`} />
          )}
        </div>
      </FormGroup>
    </DialogContent>
  );
}
